import { PumpingServicePropertyValues } from '@cemex-core/cmx-api';
import { CemexPumpActions, LOAD_PUMPING_SERVICE_COMPLETE } from '../../actions/cemex-pump.actions';

export interface CemexPumpState {
  properties: PumpingServicePropertyValues[];
  serviceId: number;
}

export const initialState: CemexPumpState = {
  properties: [],
  serviceId: null,
};

export function cemexPumpReducer(state = initialState, action: CemexPumpActions): CemexPumpState {
  switch (action.type) {
    case LOAD_PUMPING_SERVICE_COMPLETE: {
      return {
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
